<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['no']" :placeholder="$t('placeholder.purchaseOrderNo')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['supplier.name']" :placeholder="$t('placeholder.supplierName')" @pressEnter="search" @search="search"/>
      <a-select v-model="query['storer.id']" :placeholder="$t('placeholder.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <a-date-picker v-model="query.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" show-today valueFormat="YYYY-MM-DD"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="search"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exportExcel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      style="margin-top: 2px">
      <vxe-column fixed="left" sortable title="business.label.index" type="seq" width="50"/>
      <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
      <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
      <vxe-column field="orderType.name" sortable title="business.label.orderType" width="120"/>
      <vxe-column field="order.orderStatus" sortable title="business.label.orderStatus" width="100">
        <span slot-scope="{ row }">{{orderStatusData.find(item => item.ordinal === row.order.orderStatus).name}}</span>
      </vxe-column>
      <vxe-column field="storer.name" sortable title="business.label.storerName" width="120"/>
      <vxe-column field="supplier.name" sortable title="business.label.supplierName"/>
      <vxe-column field="order.operator" sortable title="business.label.maker"/>
      <vxe-column field="order.buyer" sortable title="business.label.buyer"/>
      <vxe-column field="logicalStore.name" sortable title="business.label.logicalStore"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'PurchaseOrderQuery',
  data() {
    return {
      data: [],
      orderStatusData: [],
      storerData: [],
      loading: false,
      size: 20,
      page: 1,
      contentSize: 0,
      query: {
        'no': '',
        'supplier.name': '',
        'storer.id': undefined,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条
    }
  },
  mounted() {
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storerData = res.result
      }
    })
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatusData = res.result
      }
    })
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.dateFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.dateFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      let args = Object.assign({}, this.query)
      if (args.dateFilter.start === null && args.dateFilter.end === null) {
        args.dateFilter = null
      }
      findAll('purchaseOrderFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          setTimeout(() => {
            this.loading = false
          }, 300)
        } else {
          this.loading = false
        }
      })
    },
    search() {
      this.page = 1
      this.getData()
    },
    exportExcel() {
      this.$refs.table.openExport()
    },
    reset() {
      this.query = {
        'no': '',
        'supplier.name': '',
        'storer.id': undefined,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      }
      this.page = 1
      this.getData()
    }
  }
}
</script>
<style scoped>
.query {
  width: 180px;
}
</style>